"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanReducer = void 0;
function booleanReducer(state, action) {
    switch (action) {
        case 'false':
            return false;
        case 'true':
            return true;
        case 'toggle':
            return !state;
        default:
            return state;
    }
}
exports.booleanReducer = booleanReducer;
//# sourceMappingURL=boolean-reducer.js.map